import * as t from "io-ts";
import { isLeft } from "fp-ts/lib/Either";

const copyTemplateMessageCodec = t.intersection([
    t.type({
        kind: t.literal("copy-template"),
        templateID: t.string,
    }),
    t.partial({ onBehalfOf: t.string }),
]);

export type CopyTemplateMessage = t.TypeOf<typeof copyTemplateMessageCodec>;

export function encodeCopyTemplateMessage(templateID: string, onBehalfOf?: string): CopyTemplateMessage {
    return { kind: "copy-template", templateID, onBehalfOf };
}

export function decodeCopyTemplateMessage(o: unknown): CopyTemplateMessage | undefined {
    const decoded = copyTemplateMessageCodec.decode(o);
    return isLeft(decoded) ? undefined : decoded.right;
}
